var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-primary",class:[{'fullwidth': _vm.fullWidth}, {visible: _vm.visible}, _vm.cssClass, _vm.position]},[(_vm.dismissible)?_c('button',{staticClass:"delete",on:{"click":_vm.clickClose}}):_vm._e(),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }